import React, { createContext, useContext, useState } from 'react';

const PublicContext = createContext();

export const PublicProvider = ({ children }) => {
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

    const openDemoModal = () => setIsDemoModalOpen(true);
    const closeDemoModal = () => setIsDemoModalOpen(false);

    return (
        <PublicContext.Provider value={{
            isDemoModalOpen,
            openDemoModal,
            closeDemoModal
        }}>
            {children}
        </PublicContext.Provider>
    );
};

export const usePublic = () => {
    const context = useContext(PublicContext);
    if (!context) {
        throw new Error('usePublic must be used within a PublicProvider');
    }
    return context;
};
